import { render } from "./pfooter.vue?vue&type=template&id=abe22580&scoped=true"
import script from "./pfooter.vue?vue&type=script&lang=js"
export * from "./pfooter.vue?vue&type=script&lang=js"

import "./pfooter.vue?vue&type=style&index=0&id=abe22580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe22580"]])

export default __exports__